import React from 'react'

function TransactionItemWrongWorkflow ({ wrongWorkflowData }) {

  const messages = wrongWorkflowData && wrongWorkflowData.messages && wrongWorkflowData.messages.map(x => <li>{x}<hr /></li>) 

  return (
    <ul>
      { messages }
    </ul>
  )
}

export default TransactionItemWrongWorkflow



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionItemWrongWorkflow.js